export const COACH_ROLE_NAME = 'Coach';
export const JUNIOR_COACH_ROLE_NAME = 'Junior Coach';
export const PROVISIONAL_COACH_ROLE_NAME = 'Provisional Coach';
export const ATHLETE_ROLE_NAME = 'Athlete';
export const COACH_ORG_ROLE_FIELD_NAME = 'Full_Part_Time';

const ClubConstants = {
  COACH_ROLE_NAME,
  JUNIOR_COACH_ROLE_NAME,
  PROVISIONAL_COACH_ROLE_NAME,
  ATHLETE_ROLE_NAME,
  COACH_ORG_ROLE_FIELD_NAME
};

export default ClubConstants;